module.exports = __webpack_public_path__ + "static/img/memberJb.0a5ae470.png";